import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-newsletter-checkbox-label',
  imports: [],
  templateUrl: './newsletter-checkbox-label.component.html',
  styleUrl: './newsletter-checkbox-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterCheckboxLabelComponent {}
